import * as React from 'react';

import { HStack, Header } from '@rbilabs/universal-components';

import TrophyIcon from 'components/icons/trophy';

import { getQuestText } from '../custom-text';

export const QuestLibraryHeader = () => {
  return (
    <HStack>
      <TrophyIcon mt={{ base: '$1_5', md: '$2' }} />
      <Header ml={{ base: '$2', md: '$3' }}>{getQuestText()}</Header>
    </HStack>
  );
};
